import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  admanagementTool: EMPTY_STRING,
  ratecardId: null,
  contractReference: EMPTY_STRING,
};
